import { render, staticRenderFns } from "./helpActive.vue?vue&type=template&id=9781eb50&scoped=true&"
import script from "./helpActive.vue?vue&type=script&lang=js&"
export * from "./helpActive.vue?vue&type=script&lang=js&"
import style0 from "./helpActive.vue?vue&type=style&index=0&id=9781eb50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9781eb50",
  null
  
)

export default component.exports